<template>
    <div class="Topcont">

        <div class="container">
            <div class="tree">
                <el-input placeholder="输入关键字进行过滤" v-model="filterText">
                </el-input>

                <el-tree class="filter-tree" :data="data" :props="defaultProps" default-expand-all
                    :filter-node-method="filterNode" ref="tree" @node-click="nodeclickFc">
                </el-tree>
            </div>
            <div v-if="this.datalist.length>0">
                <div class="card-Hero" v-for="(i,index) in  this.datalist" :key="index" data-aos="slide-right"
                    data-aos-offset="200" data-aos-delay="500" data-aos-duration="2000" data-aos-easing="linear">
                    <div class="content-Hero">
                        <h2>{{i.locatName}}</h2>
                        <p>{{i.locatCode}}</p>
                        <!-- <p> <a type="primary" @click="">同步人员</a></p> -->
                        <a @click="godetail">详情</a>
                    </div>
                    <div class="content-bottmo">
                        <div @click="Tbclick(i)" style="cursor:pointer ;">
                            <h2 class="content-ftsize">人员列表</h2>
                            <p>{{infostatus.userCount}}</p>

                        </div>
                        <div>
                            <h2 class="content-ftsize">库存数量</h2>
                            <!-- <p>详情</p> -->
                            <p>{{infostatus.storeCount}}</p>
                        </div>
                        <div>
                            <h2 class="content-ftsize">立即盘点</h2>
                            <p style="cursor: pointer;" @click="PadPage">进入</p>

                        </div>
                        <div>
                            <h2 class="content-ftsize">在线状态</h2>

                            <p v-if="infostatus.isOnLine" style="color: rgb(7, 253, 7);">在线</p>
                            <p v-else style="color: rgb(214, 18, 12);">离线</p>

                        </div>

                    </div>

                    <img src="./img/gzg.png">
                </div>
            </div>
            <div style="position: absolute;left: 50%; top: 50%;transform: translate(-50%,-50%);" v-else>
                <el-empty :image-size="200"></el-empty>
            </div>


        </div>
        <el-drawer class="modules" :show-close="false" style="width: 100%;" :visible.sync="drawer"
            :before-close="handleClose">
            <div style="margin: 20px;">
                <div class="ConFinTile">详情页</div>
                <div style="display: flex;align-items: center;">
                    <div class="Xfbg">
                        <div class="TpT">商户名称</div>
                        <div class="TpB">12312</div>
                    </div>
                    <div class="Xfbg">
                        <div class="TpT">商户号</div>
                        <div class="TpB">12312</div>
                    </div>
                </div>
            </div>
        </el-drawer>
        <el-dialog class="modules" title="盘点" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">
            <div class="ConFinTile">汇总信息</div>
            <el-table ref="multipleTable" class="more_btn" v-loading="loading" element-loading-text="拼命加载中，请稍候......"
                @cell-click="cellclick" :header-cell-style="getRowClass" highlight-current-row :data="gridData"
                style="width: 100%" @selection-change="handleSelectionChange" border>
                <el-table-column type="selection" width="55">
                </el-table-column>
                <!-- <el-table-column type="index" label="序号" width="50"></el-table-column> -->
                <el-table-column property="date" label="物品名称" width="150"></el-table-column>
                <el-table-column property="name" label="数量" width="200"></el-table-column>
                <el-table-column property="address" label="规格"></el-table-column>
                <el-table-column property="address" label="批号"></el-table-column>
                <el-table-column property="address" label="供应商"></el-table-column>
                <el-table-column property="address" label="有效期"></el-table-column>
            </el-table>
            <div class="ConFinTile">详情信息</div>
            <el-table class="more_btn" v-loading="loading" element-loading-text="拼命加载中，请稍候......" @select="selectCur"
                :header-cell-style="getRowClass" highlight-current-row :data="gridData" style="width: 100%" border>
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column property="date" label="状态" width="150"></el-table-column>
                <el-table-column property="name" label="编码" width="200"></el-table-column>
                <el-table-column property="address" label="物品名称"></el-table-column>
                <el-table-column property="address" label="规格"></el-table-column>
                <el-table-column property="address" label="柜位"></el-table-column>
                <el-table-column property="address" label="有效期"></el-table-column>
                <el-table-column property="address" label="批号"></el-table-column>
                <el-table-column property="address" label="供应商"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>

    </div>


</template>

<script>
    import * as apiModules from '@/api/modules'

    export default {
        name: 'uploadFile',
        data() {
            return {
                input3: '',
                datalist: {},
                infostatus: {},
                drawer: false,
                gridData: [{
                    date: '2016-05-02',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                }, {
                    date: '2016-05-04',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                }, {
                    date: '2016-05-01',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                }, {
                    date: '2016-05-03',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                }],
                filterText: '',
                data: [],
                defaultProps: {
                    children: 'sheBeiList',
                    label: 'locatName'
                },
                dialogVisible: false,
                multipleSelection: [],

            }
        },
        watch: {
            filterText(val) {
                this.$refs.tree.filter(val);
            }
        },
        created() {
            this.getlist()
            // this.GetHvOnlineInfo()
            // this.Sync()
        },
        methods: {
            getRowClass() {
                return 'background:#F6F8FA'
            },

            // 选择变化时
            handleSelectionChange(val) {

                console.log(val);
                // console.log(val.pop());
                if (val.length > 1) {
                    this.$refs.multipleTable.clearSelection()
                    this.$refs.multipleTable.toggleRowSelection(val.pop())
                }
            },
            cellclick(row) {
                if (this.multipleSelection[0] == row) {  // 选中的是已有的 取消选中
                    this.multipleSelection = [];
                    this.$refs['multipleTable'].clearSelection();
                } else {
                    this.multipleSelection = [row];
                    this.$refs['multipleTable'].clearSelection();
                    this.$refs['multipleTable'].toggleRowSelection(row, true);
                }


            },




            filterNode(value, data) {
                console.log(value, data);
                if (!value) return true;
                return data.locatName.indexOf(value) !== -1;
            },
            nodeclickFc(row) {
                console.log(row);

                this.datalist = Array(row)
                this.GetHvOnlineInfo(row)
                this.Sync(row)
            },
            getlist() {
                apiModules.GetHvInfoList('').then(response => {

                    this.data = response.result

                })
            },
            GetHvOnlineInfo(row) {
                let DT = {
                    cabNum: row.locatName
                }
                apiModules.GetHvOnlineInfo(DT).then(response => {
                    this.infostatus = response.result
                })
            },
            Sync(row) {
                let GnBd = {
                    cabNum: row.locatName,
                    deptCode: row.locatCode,
                    action: 'GetStockInfo'
                }
                apiModules.Sync(GnBd).then(response => {
                    // this.datalist = response.result
                    // console.log(this.datalist);
                })
            },
            godetail() {
                this.drawer = true
            },
            PadPage() {
                this.dialogVisible = true
            },
            Tbclick(row) {
                console.log(row);
                let TBXX = {
                    deptId: row.locatCode,
                    deptCode: row.locatCode,
                    deptName: row.locatName
                }
                apiModules.SyncDept(TBXX).then(response => {
                    if (response.code == 200) {
                        this.$message.success(response.message)
                    } else {
                        this.$message.error(response.message)
                    }

                })
            }

        },

    }
</script>
<style scoped lang='less'>
    /* // *{
    //     margin: 0;
    //     padding: 0;
    //     box-sizing: border-box;
    //     font-family: 'Poppins', sans-serif;
    // } */
    body {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
        background-image: linear-gradient(to bottom right, #546fff, #8be1fd);
    }

    .container {
        /* // margin-top:(100vh - 80px);
        // width:100vw; */
        /* position: relative; */
        display: flex;
        /* justify-content: space-between; */
        /* align-items: center; */
        background-color: #fff;
        height: 86vh;

    }

    .container .card-Hero {
        position: relative;
        width: 400px;
        height: 300px;
        margin: 20px;
        display: flex;
        transition: 0.5s;
        justify-content: flex-start;
        align-items: center;
        background: linear-gradient(89deg, #1486F8, #22B8E2);
        border-radius: 15px;
    }

    .container .card-Hero img {
        position: absolute;
        bottom: 25%;
        /* left: 50%; */
        transform: translateX(-50%);
        height: 200px;
        transition: 0.5s;
        left: 76%;
        height: 200px;
    }

    /* .container .card-Hero:hover img {
        left: 66%;
        height: 200px;
    } */

    .container .card-Hero .content-Hero {
        position: relative;
        width: 50%;
        left: 0%;
        top: -10%;
        padding: 20px 20px 20px 40px;
        /* opacity: 0; */
        /* visibility: hidden; */
        /* transition: 0.5s; */
    }

    .content-bottmo {
        width: 100%;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        position: absolute;
        bottom: 0;
        /* left: 10px; */
        color: #fff;

        div {
            margin-right: 10px;
            text-align: center;

        }
    }

    .content-ftsize {
        font-size: 16px
    }

    /* .container .card-Hero:hover .content-Hero {
        left: 0;
        opacity: 1;
        visibility: visible;
    } */

    .container .card-Hero .content-Hero h2 {
        color: #fff;
        text-transform: uppercase;
        font-size: 30px;
        line-height: 1.2em;
    }

    .container .card-Hero .content-Hero p {
        color: #fff;
        margin: 6px 0 5px 0;
    }

    .container .card-Hero .content-Hero a {
        position: relative;
        color: #111;
        background: #fff;
        display: inline-block;
        padding: 10px 20px;
        margin-top: 10px;
        text-decoration: none;
        font-weight: 700;
        border-radius: 5px;
    }

    @media (max-width: 991px) {
        .container {
            flex-direction: column;
        }

        .container .card-Hero {
            margin: 40px 20px;
        }

        /* // .container .card-Hero{
        //     width: auto;
        //     max-width: 600px;
        //     align-items: flex-start;
        // }
        // .container .card-Hero:hover{
        //     height: 600px;
        // }
        // .container .card-Hero:hover img{
        //     left: 50%;
        //     height: 350px;
        // }
        // .container .card-Hero .content-Hero{
        //     width: 100%;
        //     left: 0;
        //     padding: 40px;
        // } */
    }

    @media (max-width: 767px) {
        .container {
            flex-direction: column;
        }

        .container .card-Hero {
            margin: 40px 20px;
        }
    }

    @media (max-width: 420px) {

        .container .card-Hero .content-Hero {
            padding: 30px;
        }

        .container .card-Hero:hover img {
            height: 300px;
        }
    }

    @media (max-width: 330px) {
        .container .card-Hero:hover {
            height: 640px;
        }
    }

    .harder {
        margin: 20px 20px 30px 20px;
    }

    /deep/ .el-drawer {
        width: 30% !important;
    }


    .tree {
        /* background-color: #ccc; */
        height: 100%;
        margin: 20px;
        width: 230px;
    }

    /* // 将全选项隐藏 */
    .Xfbg {
        flex: 50%;

        .TpT {
            color: #9999;
            margin-bottom: 4px;
        }

        .TpB {
            font-size: 18px;
        }
    }
</style>